module.exports = __webpack_public_path__ + "img/GameLog.c6216257.png";